//natives
import React, { Component } from 'react';

//components
import Pedidos from '../../../../../../util/consultaPedidos/.mixins';

export default class Agendados extends Component {
    render() {
        return(<Pedidos {...this.props}/>);
    }
}